import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';

/**
 * @param {{ to: string, title: string, description?: string, icon?: string, status?: 'active' | 'prepared' | 'soon' }} props
 */
export function ModuleCard({ to, title, description, icon = '◆', status = 'soon' }) {
  const { t } = useApp();
  const statusLabel =
    status === 'active' ? t('productStatus.active') : status === 'prepared' ? t('productStatus.prepared') : t('productStatus.soon');

  return (
    <Link to={to} className={`module-card module-card--${status}`}>
      <span className="module-card__icon" aria-hidden>
        {icon}
      </span>
      <div className="module-card__body">
        <div className="module-card__head">
          <span className="module-card__title">{title}</span>
          <span className={`module-card__status module-card__status--${status}`}>{statusLabel}</span>
        </div>
        {description ? <span className="module-card__desc">{description}</span> : null}
      </div>
      <span className="module-card__arrow" aria-hidden>
        →
      </span>
    </Link>
  );
}
